class EditorialCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-editorial-carousel-scroller]');
    this.prevButton = this.querySelector('[data-editorial-carousel-prev]');
    this.nextButton = this.querySelector('[data-editorial-carousel-next]');
    this.current = this.querySelector('[data-editorial-carousel-current]');
    this.total = this.querySelector('[data-editorial-carousel-total]');
    this.cards = Array.from(this.querySelectorAll('[data-editorial-carousel-card]'));

    if (!this.scroller || this.cards.length === 0) return;

    this.prevButton?.addEventListener('click', this.scrollPrevious);
    this.nextButton?.addEventListener('click', this.scrollNext);
    this.scroller.addEventListener('scroll', this.updateState, { passive: true });
    window.addEventListener('resize', this.updateState);

    this.updateState();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.scrollPrevious);
    this.nextButton?.removeEventListener('click', this.scrollNext);
    this.scroller?.removeEventListener('scroll', this.updateState);
    window.removeEventListener('resize', this.updateState);
  }

  scrollPrevious = () => {
    this.scrollByCards(-1);
  };

  scrollNext = () => {
    this.scrollByCards(1);
  };

  scrollByCards(direction) {
    const card = this.cards[0];
    if (!card || !this.scroller) return;

    const gap = Number.parseFloat(getComputedStyle(this.scroller).columnGap || 0);
    const distance = card.getBoundingClientRect().width + gap;

    this.scroller.scrollBy({
      left: distance * direction,
      behavior: 'smooth',
    });
  }

  updateState = () => {
    if (!this.scroller || this.cards.length === 0) return;

    const scrollerLeft = this.scroller.getBoundingClientRect().left;
    const activeIndex = this.cards.reduce((closestIndex, card, index) => {
      const currentDistance = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
      const closestDistance = Math.abs(this.cards[closestIndex].getBoundingClientRect().left - scrollerLeft);

      return currentDistance < closestDistance ? index : closestIndex;
    }, 0);

    const currentValue = activeIndex + 1;
    const maxScrollLeft = this.scroller.scrollWidth - this.scroller.clientWidth - 2;

    if (this.current) this.current.textContent = currentValue;
    if (this.total) this.total.textContent = this.cards.length;

    this.prevButton?.toggleAttribute('disabled', this.scroller.scrollLeft <= 2);
    this.nextButton?.toggleAttribute('disabled', this.scroller.scrollLeft >= maxScrollLeft);
  };
}

if (!customElements.get('editorial-carousel')) {
  customElements.define('editorial-carousel', EditorialCarousel);
}
